<template>
    <Card
        icon="fas fa-clock"
        bg-color="tw:bg-[var(--sitecolor)]"
        title-color="white"
        title-classes="tw:border-b tw:border-gray-200"
        :title="'Preventa'"
        padding="0"
    >
        <div class="tw:p-6 tw:space-y-4">
            <ToggleSwitch
                :value="localData.preventa_configurada"
                @input="val => set(localData, 'preventa_configurada', val)"
                variant="primary"
                data-cy="activar-preventa"
                id="activar_preventa"
            >
                {{ 'Activar acceso a la preventa' }}
            </ToggleSwitch>

            <div v-if="localData.preventa_configurada" ref="preventaSection">

                <div class="tw:mb-6">
                    <label class="tw:block tw:text-sm tw:font-medium tw:text-gray-700 tw:mb-1">
                        {{ 'Texto para registro de preventa' }}
                    </label>
                    <QuillEditor
                        ref="editorRegistroPreventa"
                        :value="localData.texto_registro_preventa"
                        @input="val => localData.texto_registro_preventa = val"
                    />
                </div>

                <div>
                    <label class="tw:block tw:text-sm tw:font-medium tw:text-gray-700 tw:mb-1">
                        {{ 'Condiciones legales preventa' }}
                    </label>
                    <QuillEditor
                        ref="editorCondicionesLegales"
                        :value="localData.texto_condiciones_legales_preventa"
                        @input="val => localData.texto_condiciones_legales_preventa = val"
                    />
                </div>

                <div class="tw:border-t tw:border-gray-100 tw:mb-4 tw:mt-6"></div>

                <div class="tw:mb-4">
                    <div class="tw:flex tw:items-center tw:gap-1 tw:mb-1">
                        <label class="tw:text-sm tw:font-medium tw:text-gray-700 tw:m-0">
                            {{ 'Rango acceso' }}
                        </label>
                        <Tooltip
                            :text="'Selecciona el rango para poder solicitar acceso a la preventa'"
                            variant="success"
                            class="tw:normal-case"
                        />
                    </div>
                    <div class="tw:grid tw:grid-cols-1 tw:md:grid-cols-2 tw:gap-4">
                        <div>
                            <BaseDateTimeInput
                                :label="'Fecha apertura registro preventa'"
                                name="registro_preventa_desde"
                                :value="localData.registro_preventa_desde"
                                rules="required"
                                :max="toDateTimeInputFormat(localData.registro_preventa_hasta || maxPreventaDate)"
                                @input="val => set(localData, 'registro_preventa_desde', val)"
                            />
                            <span class="tw:text-gray-500 tw:tracking-wide tw:mt-1 tw:text-end tw:text-[11px] tw:block">
                                {{ '(DESDE)' }}
                            </span>
                        </div>
                        <div>
                            <BaseDateTimeInput
                                :label="'Fecha cierre registro preventa'"
                                name="registro_preventa_hasta"
                                :value="localData.registro_preventa_hasta"
                                rules="required"
                                :min="toDateTimeInputFormat(localData.registro_preventa_desde)"
                                :max="toDateTimeInputFormat(maxPreventaDate)"
                                @input="val => set(localData, 'registro_preventa_hasta', val)"
                            />
                            <span class="tw:text-gray-500 tw:tracking-wide tw:mt-1 tw:text-end tw:text-[11px] tw:block">
                                {{ '(HASTA)' }}
                            </span>
                        </div>
                    </div>
                </div>

                <div class="tw:mb-4">
                    <div class="tw:flex tw:items-center tw:gap-1 tw:mb-1">
                        <label class="tw:text-sm tw:font-medium tw:text-gray-700 tw:m-0">
                            {{ 'Rango compra' }}
                        </label>
                        <Tooltip
                            :text="'Selecciona el rango para poder comprar en la preventa'"
                            variant="success"
                            class="tw:normal-case"
                        />
                    </div>
                    <div class="tw:grid tw:grid-cols-1 tw:md:grid-cols-2 tw:gap-4">
                        <div>
                            <BaseDateTimeInput
                                :label="'Fecha apertura venta preventa'"
                                name="venta_preventa_desde"
                                :value="localData.venta_preventa_desde"
                                rules="required"
                                :max="toDateTimeInputFormat(localData.venta_preventa_hasta || maxPreventaDate)"
                                @input="val => set(localData, 'venta_preventa_desde', val)"
                            />
                            <span class="tw:text-gray-500 tw:tracking-wide tw:mt-1 tw:text-end tw:text-[11px] tw:block">
                                {{ '(DESDE)' }}
                            </span>
                        </div>
                        <div>
                            <BaseDateTimeInput
                                :label="'Fecha cierre venta preventa'"
                                name="venta_preventa_hasta"
                                :value="localData.venta_preventa_hasta"
                                rules="required"
                                :min="toDateTimeInputFormat(localData.venta_preventa_desde)"
                                :max="toDateTimeInputFormat(maxPreventaDate)"
                                @input="val => set(localData, 'venta_preventa_hasta', val)"
                            />
                            <span class="tw:text-gray-500 tw:tracking-wide tw:mt-1 tw:text-end tw:text-[11px] tw:block">
                                {{ '(HASTA)' }}
                            </span>
                        </div>
                    </div>
                </div>

                <div class="tw:border-t tw:border-gray-100 tw:my-4"></div>

                <div>
                    <div class="tw:flex tw:items-center tw:gap-1 tw:mb-1">
                        <label class="tw:text-sm tw:font-medium tw:text-gray-700 tw:m-0">
                            {{ 'Nº máximo de entradas' }}
                        </label>
                        <Tooltip
                            :text="'Este será el número máximo de entradas que se podrán comprar en la preventa en este evento.'"
                            variant="success"
                            class="tw:normal-case"
                        />
                    </div>
                    <BaseInputNumber
                        id="n_entrada_max_preventa"
                        name="número máximo de entradas para la preventa"
                        :label="'Cantidad total'"
                        data-cy="n_entrada_max_preventa"
                        :value="localData.n_entrada_max_preventa"
                        rules="required|numeric"
                        :min="1"
                        @input="val => set(localData, 'n_entrada_max_preventa', val)"
                    />
                </div>
            </div>
        </div>
    </Card>
</template>

<script setup>
    import { ref, inject, set } from 'vue';
    import { useScrollOnToggle } from '@/composables/common/useScrollOnToggle';
    import Card from '@/modules/admin/ui/Card.vue';
    import BaseInputText from '@/modules/admin/ui/BaseInputText.vue';
    import BaseInputNumber from '@/modules/admin/ui/BaseInputNumber.vue';
    import ToggleSwitch from '@/modules/admin/ui/ToggleSwitch.vue';
    import QuillEditor from '@/modules/ui/QuillEditor.vue';
    import BaseDateTimeInput from '@/modules/admin/ui/BaseDateTimeInput.vue';
    import Tooltip from '@/modules/admin/ui/Tooltip.vue';
    import { toDateTimeInputFormat } from '@/utils/dateUtils';

    const localData = inject('eventoFormData');

    defineProps({
        maxPreventaDate: { type: Date, default: null }
    });

    const editorRegistroPreventa = ref(null);
    const editorCondicionesLegales = ref(null);
    const preventaSection = ref(null);

    defineExpose({
        editorRegistroPreventa,
        editorCondicionesLegales
    });

    useScrollOnToggle(() => localData.preventa_configurada, preventaSection);
</script>
